import { createAction } from '@reduxjs/toolkit';

export const getInitialSlice = (slices, initialStates) =>
  slices.reduce((acc, curr) => {
    acc[curr] = initialStates[curr];
    return acc;
  }, {});

export const resetSlices = createAction('resetState/resetSlices');
export const restoreState = createAction('resetState/restoreState');
export const resetStateToInitial = createAction('resetState/resetToInitial');
